export const flightListOfOneway = {
  data: {
    availabilityv4: {
      results: [
        {
          trips: [
            {
              date: "2022-06-21T00:00:00",
              journeysAvailableByMarket: [
                {
                  key: "BLR|PNQ",
                  value: [
                    {
                      journeyKey: "UVB_IDUwOX4gfn5CTFJ_MDYvMjEvMjAyMiAwNjowMH5QTlF_MDYvMjEvMjAyMiAwNzoyMH5_",
                      designator: {
                        arrival: "2022-06-21T07:20:00",
                        departure: "2022-06-21T06:00:00",
                        destination: "PNQ",
                        origin: "BLR",
                        __typename: "TransportationDesignator"
                      },
                      stops: 0,
                      fares: [
                        {
                          fareAvailabilityKey: "MH5Wfn5RUH5WTzdSQklOWH4xMDAxfn4xfjF_TkJMUlBOUTAwMTAwMTB_WCEw",
                          details: [
                            {
                              reference: "MH5Wfn5RUH5WTzdSQklOWH4xMDAxfn4xfjF_TkJMUlBOUTAwMTAwMTB_WA--",
                              status: "Active",
                              availableCount: 18,
                              bundleReferences: null,
                              ssrReferences: null,
                              serviceBundleSetCode: null,
                              __typename: "AvailableJourneyFareDetail"
                            }
                          ],
                          __typename: "AvailableJourneyFare"
                        }
                      ],
                      segments: [
                        {
                          segmentKey: "UVB_IDUwOX4gfn5CTFJ_MDYvMjEvMjAyMiAwNjowMH5QTlF_MDYvMjEvMjAyMiAwNzoyMH5_",
                          identifier: {
                            carrierCode: "QP",
                            identifier: "509",
                            opSuffix: null,
                            __typename: "TransportationIdentifier"
                          },
                          designator: {
                            arrival: "2022-06-21T07:20:00",
                            departure: "2022-06-21T06:00:00",
                            destination: "PNQ",
                            origin: "BLR",
                            __typename: "TransportationDesignator"
                          },
                          legs: [
                            {
                              designator: {
                                arrival: "2022-06-21T07:20:00",
                                departure: "2022-06-21T06:00:00",
                                destination: "PNQ",
                                origin: "BLR",
                                __typename: "TransportationDesignator"
                              },
                              flightReference: "20220621 QP 509 BLRPNQ",
                              legInfo: {
                                adjustedCapacity: 189,
                                arrivalTerminal: null,
                                arrivalTime: "2022-06-21T07:20:00",
                                arrivalTimeUtc: "2022-06-21T01:50:00Z",
                                capacity: 189,
                                departureTerminal: null,
                                departureTime: "2022-06-21T06:00:00",
                                departureTimeUtc: "2022-06-21T00:30:00Z",
                                eTicket: true,
                                __typename: "LegInformation"
                              },
                              ssrs: [],
                              __typename: "Leg"
                            }
                          ],
                          __typename: "AvailableSegment"
                        }
                      ],
                      __typename: "AvailableJourney"
                    },
                    {
                      journeyKey:
                        "UVB_IDUwMH4gfn5CTFJ_MDYvMjEvMjAyMiAwNjowMH5BTUR_MDYvMjEvMjAyMiAwODoxMH5_XlFQfiA1MDZ_IH5_QU1EfjA2LzIxLzIwMjIgMTQ6NDV_UE5RfjA2LzIxLzIwMjIgMTY6MTB_fg--",
                      designator: {
                        arrival: "2022-06-21T16:10:00",
                        departure: "2022-06-21T06:00:00",
                        destination: "PNQ",
                        origin: "BLR",
                        __typename: "TransportationDesignator"
                      },
                      stops: 1,
                      fares: [
                        {
                          fareAvailabilityKey: "MH5Wfn5RUH5WTzdSQklOWH4xMDAxfn4xfjF_TkJMUlBOUTAwMTAwMTB_WCEx",
                          details: [
                            {
                              reference: "MH5Wfn5RUH5WTzdSQklOWH4xMDAxfn4xfjF_TkJMUlBOUTAwMTAwMTB_WA--",
                              status: "Active",
                              availableCount: 3,
                              bundleReferences: null,
                              ssrReferences: null,
                              serviceBundleSetCode: null,
                              __typename: "AvailableJourneyFareDetail"
                            }
                          ],
                          __typename: "AvailableJourneyFare"
                        }
                      ],
                      segments: [
                        {
                          segmentKey: "UVB_IDUwMH4gfn5CTFJ_MDYvMjEvMjAyMiAwNjowMH5BTUR_MDYvMjEvMjAyMiAwODoxMH5_",
                          identifier: {
                            carrierCode: "QP",
                            identifier: "500",
                            opSuffix: null,
                            __typename: "TransportationIdentifier"
                          },
                          designator: {
                            arrival: "2022-06-21T08:10:00",
                            departure: "2022-06-21T06:00:00",
                            destination: "AMD",
                            origin: "BLR",
                            __typename: "TransportationDesignator"
                          },
                          legs: [
                            {
                              designator: {
                                arrival: "2022-06-21T08:10:00",
                                departure: "2022-06-21T06:00:00",
                                destination: "AMD",
                                origin: "BLR",
                                __typename: "TransportationDesignator"
                              },
                              flightReference: "20220621 QP 500 BLRAMD",
                              legInfo: {
                                adjustedCapacity: 189,
                                arrivalTerminal: "T1",
                                arrivalTime: "2022-06-21T08:10:00",
                                arrivalTimeUtc: "2022-06-21T02:40:00Z",
                                capacity: 189,
                                departureTerminal: "T1",
                                departureTime: "2022-06-21T06:00:00",
                                departureTimeUtc: "2022-06-21T00:30:00Z",
                                eTicket: true,
                                __typename: "LegInformation"
                              },
                              ssrs: [],
                              __typename: "Leg"
                            }
                          ],
                          __typename: "AvailableSegment"
                        },
                        {
                          segmentKey: "UVB_IDUwNn4gfn5BTUR_MDYvMjEvMjAyMiAxNDo0NX5QTlF_MDYvMjEvMjAyMiAxNjoxMH5_",
                          identifier: {
                            carrierCode: "QP",
                            identifier: "506",
                            opSuffix: null,
                            __typename: "TransportationIdentifier"
                          },
                          designator: {
                            arrival: "2022-06-21T16:10:00",
                            departure: "2022-06-21T14:45:00",
                            destination: "PNQ",
                            origin: "AMD",
                            __typename: "TransportationDesignator"
                          },
                          legs: [
                            {
                              designator: {
                                arrival: "2022-06-21T16:10:00",
                                departure: "2022-06-21T14:45:00",
                                destination: "PNQ",
                                origin: "AMD",
                                __typename: "TransportationDesignator"
                              },
                              flightReference: "20220621 QP 506 AMDPNQ",
                              legInfo: {
                                adjustedCapacity: 189,
                                arrivalTerminal: "T1",
                                arrivalTime: "2022-06-21T16:10:00",
                                arrivalTimeUtc: "2022-06-21T10:40:00Z",
                                capacity: 189,
                                departureTerminal: null,
                                departureTime: "2022-06-21T14:45:00",
                                departureTimeUtc: "2022-06-21T09:15:00Z",
                                eTicket: true,
                                __typename: "LegInformation"
                              },
                              ssrs: [],
                              __typename: "Leg"
                            }
                          ],
                          __typename: "AvailableSegment"
                        }
                      ],
                      __typename: "AvailableJourney"
                    },
                    {
                      journeyKey: "UVB_IDUwNn4gfn5CTFJ_MDYvMjEvMjAyMiAxMjowMH5QTlF_MDYvMjEvMjAyMiAxNjoxMH5BTUR_",
                      designator: {
                        arrival: "2022-06-21T16:10:00",
                        departure: "2022-06-21T12:00:00",
                        destination: "PNQ",
                        origin: "BLR",
                        __typename: "TransportationDesignator"
                      },
                      stops: 1,
                      fares: [
                        {
                          fareAvailabilityKey: "MH5Wfn5RUH5WTzdSQklOWH4xMDAxfn4xfjF_TkJMUlBOUTAwMTAwMTB_WCEw",
                          details: [
                            {
                              reference: "MH5Wfn5RUH5WTzdSQklOWH4xMDAxfn4xfjF_TkJMUlBOUTAwMTAwMTB_WA--",
                              status: "Active",
                              availableCount: 3,
                              bundleReferences: null,
                              ssrReferences: null,
                              serviceBundleSetCode: null,
                              __typename: "AvailableJourneyFareDetail"
                            }
                          ],
                          __typename: "AvailableJourneyFare"
                        }
                      ],
                      segments: [
                        {
                          segmentKey: "UVB_IDUwNn4gfn5CTFJ_MDYvMjEvMjAyMiAxMjowMH5QTlF_MDYvMjEvMjAyMiAxNjoxMH5BTUR_",
                          identifier: {
                            carrierCode: "QP",
                            identifier: "506",
                            opSuffix: null,
                            __typename: "TransportationIdentifier"
                          },
                          designator: {
                            arrival: "2022-06-21T16:10:00",
                            departure: "2022-06-21T12:00:00",
                            destination: "PNQ",
                            origin: "BLR",
                            __typename: "TransportationDesignator"
                          },
                          legs: [
                            {
                              designator: {
                                arrival: "2022-06-21T14:10:00",
                                departure: "2022-06-21T12:00:00",
                                destination: "AMD",
                                origin: "BLR",
                                __typename: "TransportationDesignator"
                              },
                              flightReference: "20220621 QP 506 BLRAMD",
                              legInfo: {
                                adjustedCapacity: 189,
                                arrivalTerminal: null,
                                arrivalTime: "2022-06-21T14:10:00",
                                arrivalTimeUtc: "2022-06-21T08:40:00Z",
                                capacity: 189,
                                departureTerminal: "T1",
                                departureTime: "2022-06-21T12:00:00",
                                departureTimeUtc: "2022-06-21T06:30:00Z",
                                eTicket: true,
                                __typename: "LegInformation"
                              },
                              ssrs: [],
                              __typename: "Leg"
                            },
                            {
                              designator: {
                                arrival: "2022-06-21T16:10:00",
                                departure: "2022-06-21T14:45:00",
                                destination: "PNQ",
                                origin: "AMD",
                                __typename: "TransportationDesignator"
                              },
                              flightReference: "20220621 QP 506 AMDPNQ",
                              legInfo: {
                                adjustedCapacity: 189,
                                arrivalTerminal: "T1",
                                arrivalTime: "2022-06-21T16:10:00",
                                arrivalTimeUtc: "2022-06-21T10:40:00Z",
                                capacity: 189,
                                departureTerminal: null,
                                departureTime: "2022-06-21T14:45:00",
                                departureTimeUtc: "2022-06-21T09:15:00Z",
                                eTicket: true,
                                __typename: "LegInformation"
                              },
                              ssrs: [],
                              __typename: "Leg"
                            }
                          ],
                          __typename: "AvailableSegment"
                        }
                      ],
                      __typename: "AvailableJourney"
                    }
                  ],
                  __typename: "KeyValuePair_StringGraphType_ListGraphTypeAvailableJourney"
                }
              ],
              __typename: "TripDateMarket"
            }
          ],
          __typename: "TripResult"
        }
      ],
      includeTaxesAndFees: true,
      faresAvailable: [
        {
          key: "MH5Wfn5RUH5WTzdSQklOWH4xMDAxfn4xfjF_TkJMUlBOUTAwMTAwMTB_WCEw",
          value: {
            fareAvailabilityKey: "MH5Wfn5RUH5WTzdSQklOWH4xMDAxfn4xfjF_TkJMUlBOUTAwMTAwMTB_WCEw",
            totals: {
              fareTotal: 15327,
              discountedTotal: 12000,
              __typename: "FareReferenceTotals"
            },
            fares: [
              {
                classOfService: "V",
                classType: null,
                productClass: "EC",
                fareApplicationType: "Route",
                passengerFares: [
                  {
                    discountedFare: 4000,
                    passengerType: "ADT",
                    publishedFare: 4000,
                    revenueFare: 4000,
                    serviceCharges: [
                      {
                        amount: 4000,
                        code: null,
                        currencyCode: "INR",
                        detail: null,
                        foreignAmount: 4000,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 50,
                        code: "CUTE",
                        currencyCode: "INR",
                        detail: "BLR-PNQ",
                        foreignAmount: 50,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 50,
                        code: "RCS",
                        currencyCode: "INR",
                        detail: "BLR-PNQ",
                        foreignAmount: 50,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 236,
                        code: "ASF",
                        currencyCode: "INR",
                        detail: "BLR-PNQ",
                        foreignAmount: 236,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 217,
                        code: "UDF",
                        currencyCode: "INR",
                        detail: "BLR-PNQ",
                        foreignAmount: 217,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 350,
                        code: "WFE",
                        currencyCode: "INR",
                        detail: "BLR-PNQ",
                        foreignAmount: 350,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 206,
                        code: null,
                        currencyCode: "INR",
                        detail: "TaxSum",
                        foreignAmount: 206,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      }
                    ],
                    __typename: "PassengerFareAvailability"
                  },
                  {
                    discountedFare: 4000,
                    passengerType: "SNR",
                    publishedFare: 4000,
                    revenueFare: 4000,
                    serviceCharges: [
                      {
                        amount: 4000,
                        code: null,
                        currencyCode: "INR",
                        detail: null,
                        foreignAmount: 4000,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 50,
                        code: "CUTE",
                        currencyCode: "INR",
                        detail: "BLR-PNQ",
                        foreignAmount: 50,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 50,
                        code: "RCS",
                        currencyCode: "INR",
                        detail: "BLR-PNQ",
                        foreignAmount: 50,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 236,
                        code: "ASF",
                        currencyCode: "INR",
                        detail: "BLR-PNQ",
                        foreignAmount: 236,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 217,
                        code: "UDF",
                        currencyCode: "INR",
                        detail: "BLR-PNQ",
                        foreignAmount: 217,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 350,
                        code: "WFE",
                        currencyCode: "INR",
                        detail: "BLR-PNQ",
                        foreignAmount: 350,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 206,
                        code: null,
                        currencyCode: "INR",
                        detail: "TaxSum",
                        foreignAmount: 206,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      }
                    ],
                    __typename: "PassengerFareAvailability"
                  },
                  {
                    discountedFare: 4000,
                    passengerType: "CHD",
                    publishedFare: 4000,
                    revenueFare: 4000,
                    serviceCharges: [
                      {
                        amount: 4000,
                        code: null,
                        currencyCode: "INR",
                        detail: null,
                        foreignAmount: 4000,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 50,
                        code: "CUTE",
                        currencyCode: "INR",
                        detail: "BLR-PNQ",
                        foreignAmount: 50,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 50,
                        code: "RCS",
                        currencyCode: "INR",
                        detail: "BLR-PNQ",
                        foreignAmount: 50,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 236,
                        code: "ASF",
                        currencyCode: "INR",
                        detail: "BLR-PNQ",
                        foreignAmount: 236,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 217,
                        code: "UDF",
                        currencyCode: "INR",
                        detail: "BLR-PNQ",
                        foreignAmount: 217,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 350,
                        code: "WFE",
                        currencyCode: "INR",
                        detail: "BLR-PNQ",
                        foreignAmount: 350,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 206,
                        code: null,
                        currencyCode: "INR",
                        detail: "TaxSum",
                        foreignAmount: 206,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      }
                    ],
                    __typename: "PassengerFareAvailability"
                  }
                ],
                ruleNumber: "1001",
                __typename: "FareAvailabilityv2"
              }
            ],
            __typename: "FareReference"
          },
          __typename: "KeyValuePair_StringGraphType_FareReference"
        },
        {
          key: "MH5Wfn5RUH5WTzdSQklOWH4xMDAxfn4xfjF_TkJMUlBOUTAwMTAwMTB_WCEx",
          value: {
            fareAvailabilityKey: "MH5Wfn5RUH5WTzdSQklOWH4xMDAxfn4xfjF_TkJMUlBOUTAwMTAwMTB_WCEx",
            totals: {
              fareTotal: 15327,
              discountedTotal: 12000,
              __typename: "FareReferenceTotals"
            },
            fares: [
              {
                classOfService: "V",
                classType: null,
                productClass: "EC",
                fareApplicationType: "Route",
                passengerFares: [
                  {
                    discountedFare: 4000,
                    passengerType: "ADT",
                    publishedFare: 4000,
                    revenueFare: 4000,
                    serviceCharges: [
                      {
                        amount: 4000,
                        code: null,
                        currencyCode: "INR",
                        detail: null,
                        foreignAmount: 4000,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 50,
                        code: "CUTE",
                        currencyCode: "INR",
                        detail: "BLR-AMD",
                        foreignAmount: 50,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 50,
                        code: "RCS",
                        currencyCode: "INR",
                        detail: "BLR-AMD",
                        foreignAmount: 50,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 236,
                        code: "ASF",
                        currencyCode: "INR",
                        detail: "BLR-AMD",
                        foreignAmount: 236,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 217,
                        code: "UDF",
                        currencyCode: "INR",
                        detail: "BLR-AMD",
                        foreignAmount: 217,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 350,
                        code: "WFE",
                        currencyCode: "INR",
                        detail: "BLR-AMD",
                        foreignAmount: 350,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 206,
                        code: null,
                        currencyCode: "INR",
                        detail: "TaxSum",
                        foreignAmount: 206,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      }
                    ],
                    __typename: "PassengerFareAvailability"
                  },
                  {
                    discountedFare: 4000,
                    passengerType: "SNR",
                    publishedFare: 4000,
                    revenueFare: 4000,
                    serviceCharges: [
                      {
                        amount: 4000,
                        code: null,
                        currencyCode: "INR",
                        detail: null,
                        foreignAmount: 4000,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 50,
                        code: "CUTE",
                        currencyCode: "INR",
                        detail: "BLR-AMD",
                        foreignAmount: 50,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 50,
                        code: "RCS",
                        currencyCode: "INR",
                        detail: "BLR-AMD",
                        foreignAmount: 50,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 236,
                        code: "ASF",
                        currencyCode: "INR",
                        detail: "BLR-AMD",
                        foreignAmount: 236,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 217,
                        code: "UDF",
                        currencyCode: "INR",
                        detail: "BLR-AMD",
                        foreignAmount: 217,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 350,
                        code: "WFE",
                        currencyCode: "INR",
                        detail: "BLR-AMD",
                        foreignAmount: 350,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 206,
                        code: null,
                        currencyCode: "INR",
                        detail: "TaxSum",
                        foreignAmount: 206,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      }
                    ],
                    __typename: "PassengerFareAvailability"
                  },
                  {
                    discountedFare: 4000,
                    passengerType: "CHD",
                    publishedFare: 4000,
                    revenueFare: 4000,
                    serviceCharges: [
                      {
                        amount: 4000,
                        code: null,
                        currencyCode: "INR",
                        detail: null,
                        foreignAmount: 4000,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 50,
                        code: "CUTE",
                        currencyCode: "INR",
                        detail: "BLR-AMD",
                        foreignAmount: 50,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 50,
                        code: "RCS",
                        currencyCode: "INR",
                        detail: "BLR-AMD",
                        foreignAmount: 50,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 236,
                        code: "ASF",
                        currencyCode: "INR",
                        detail: "BLR-AMD",
                        foreignAmount: 236,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 217,
                        code: "UDF",
                        currencyCode: "INR",
                        detail: "BLR-AMD",
                        foreignAmount: 217,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 350,
                        code: "WFE",
                        currencyCode: "INR",
                        detail: "BLR-AMD",
                        foreignAmount: 350,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      },
                      {
                        amount: 206,
                        code: null,
                        currencyCode: "INR",
                        detail: "TaxSum",
                        foreignAmount: 206,
                        foreignCurrencyCode: "INR",
                        __typename: "ServiceCharge"
                      }
                    ],
                    __typename: "PassengerFareAvailability"
                  }
                ],
                ruleNumber: "1001",
                __typename: "FareAvailabilityv2"
              }
            ],
            __typename: "FareReference"
          },
          __typename: "KeyValuePair_StringGraphType_FareReference"
        }
      ],
      __typename: "Availabilityv2"
    }
  }
};
